// MARK://dhk8/admin-shell/lib/queries/platform
// Queries tipadas de cuenta/tenants — F3.1 / ADR-0009. El Admin lee la Account
// (modelo test/live, owner del JWT) y los tenants por el grafo (platform-tenants).
// El switch-env y el login siguen siendo REST/auth (el JWT es la fuente del tenant).
import { graphql } from '../../gql/index.js'

export const MyAccountQuery = graphql(`
  query MyAccount {
    myAccount {
      accountId
      liveTenantId
      testTenantId
      ownerUserId
      slug
      name
    }
  }
`)

export const PlatformTenantsQuery = graphql(`
  query PlatformTenants {
    platformTenants {
      id
      tenantId
      name
      slug
      plan
      active
      suspendedAt
      deletedAt
      createdAt
      updatedAt
    }
  }
`)

export const PlatformTenantQuery = graphql(`
  query PlatformTenant($id: ID!) {
    tenant(id: $id) {
      id
      tenantId
      name
      slug
      plan
      active
      suspendedAt
      deletedAt
      createdAt
      updatedAt
    }
  }
`)

// F6.2 R3c: copia el catálogo test→live por el grafo. Owner-guard server-side
// (ctx.userId == ownerUserId de la Account del liveTenantId). Reemplaza el POST
// REST /v1/tenants/:liveId/copy-catalog-from/:testId.
export const CopyCatalogMutation = graphql(`
  mutation CopyCatalog($liveTenantId: ID!, $testTenantId: ID!) {
    copyCatalog(liveTenantId: $liveTenantId, testTenantId: $testTenantId) {
      copied
      note
    }
  }
`)


// F6.2 R3d: lifecycle de tenant (suspend/activate) por el grafo. Acciones de
// AUTORIDAD — gating server-side platform-tenants:tenant:suspend@* / activate@*.
// Reemplaza POST REST /api/tenants/:id/{suspend,activate}.
export const SuspendTenantMutation = graphql(`
  mutation SuspendTenant($id: ID!, $reason: String) {
    suspendTenant(id: $id, reason: $reason) {
      tenantId
      active
    }
  }
`)

export const ActivateTenantMutation = graphql(`
  mutation ActivateTenant($id: ID!) {
    activateTenant(id: $id) {
      tenantId
      active
    }
  }
`)
